import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { motion, useReducedMotion } from 'framer-motion';
import { Reveal } from '../../components/motion';

const NotFound: React.FC = () => {
  const prefersReducedMotion = useReducedMotion();

  return (
    <Container fluid="xl" className="py-5 text-center">
      <motion.h1
        initial={prefersReducedMotion ? false : { scale: 0.4, opacity: 0 }}
        animate={prefersReducedMotion ? undefined : { scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 220, damping: 16 }}
      >
        404
      </motion.h1>
      <Reveal as="p" className="text-muted mb-4" delay={0.2}>
        The page you're looking for doesn't exist.
      </Reveal>
      <Reveal delay={0.32}>
        <Link to="/" className="btn btn-danger">
          Back to Home
        </Link>
      </Reveal>
    </Container>
  );
};

export default NotFound;
